import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareW = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler44') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler44', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Jar drop!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Jar drop!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareW}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareW
  
